export var EAGER_LOAD_STRATEGY = 'eager'; // will render as soon as possible
export var LAZY_BROWSER_LOAD_STRATEGY = 'lazyBrowser'; // will render lazy according to browser implementation
export var IN_VIEWPORT_LOAD_STRATEGY = 'inViewport'; // will render lazy when iFrame is in viewport
export var LAZY_AFTER_USER_INTERACTION_LOAD_STRATEGY = 'lazyAfterUserInteraction'; // will render lazy according to browser implementation after the user interacts with the website

export var EMBED_LOAD_STRATEGIES = [EAGER_LOAD_STRATEGY, LAZY_BROWSER_LOAD_STRATEGY, IN_VIEWPORT_LOAD_STRATEGY, LAZY_AFTER_USER_INTERACTION_LOAD_STRATEGY];
export var EMBED_16TO9_ASPECT_RATIO = '16:9';
export var EMBED_4TO3_ASPECT_RATIO = '4:3';
export var EMBED_21TO9_ASPECT_RATIO = '21:9';
export var EMBED_ASPECT_RATIOS = [EMBED_4TO3_ASPECT_RATIO, EMBED_16TO9_ASPECT_RATIO, EMBED_21TO9_ASPECT_RATIO];
export var EMBED_SOURCE_VIMEO_TYPE = 'vimeo';
export var EMBED_SOURCE_YOUTUBE_TYPE = 'youtube';
export var EMBED_SOURCE_DEFAULT_TYPE = 'default';
export var EMBED_SOURCE_TYPES = [EMBED_SOURCE_VIMEO_TYPE, EMBED_SOURCE_YOUTUBE_TYPE, EMBED_SOURCE_DEFAULT_TYPE];